import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, Setting,
} from '@appblocks/codegeneration/types';

export default class Tibbit_62 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_62';
        this.name = 'Tibbit 62';
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/pic/PIC_LVP.tbh',
            'libraries/pic/PIC_LVP.tbs',
            'libraries/tibbits/tbt62/tbt62.tbh',
            'libraries/tibbits/tbt62/tbt62.tbs',
            'libraries/tibbits/tbt62/Tibbit62_FW_00_02.hex',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings: Array<Setting> = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies(): string[] {
        return ['unowiresensors'];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);
        if (!socket) {
            return blocks;
        }
        const currentSocket = socket.socket;
        const NAME = this.getSettingValue('NAME');

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL_NUM as byte
        `,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL_NUM as byte
        `,
        });

        const clockPin = Tibbits.getSocketPins(currentSocket, this.project.device.id)[0];
        const dataPin = Tibbits.getSocketPins(currentSocket, this.project.device.id)[1];
        const resetPin = Tibbits.getSocketPins(currentSocket, this.project.device.id)[2];
        const busyPin = Tibbits.getSocketPins(currentSocket, this.project.device.id)[3];

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 62 on socket ${socket?.socket}
    '================================================================
    select case tbt62_init("${NAME}", ${dataPin}, ${clockPin}, ${resetPin}, ${busyPin}, TBT62_METRIC_UNITS, ${NAME}_CHANNEL_NUM, NO)
    case TBT62_INIT_OK:
        sys.debugprint("tbt62> init Success\\r\\n")

    case TBT62_INIT_ERROR_SI2C_NO_EMPTY_CHANNEL:
        sys.debugprint("tbt62>No empty SI2C channel!\\r\\n")
        sys.halt()

    case TBT62_INIT_ERROR_NO_VALID_VERSION:
        sys.debugprint("tbt62>No Tibbit installed or wrong version!\\r\\n")
        sys.halt()

    case TBT62_INIT_ERROR_FAULT_CHECK_3V3:
        sys.debugprint("tbt62>Fault 3.3V check!\\r\\n")

    case TBT62_INIT_ERROR_FAULT_CHECK_VCC:
        sys.debugprint("tbt62>Fault VCC check!\\r\\n")

    case TBT62_INIT_ERROR_POWER_FAULT_CHECK:
        sys.debugprint("tbt62>Fault PowerFault signal check!\\r\\n")

    end select
    sys.debugprint("Set VCC on - ")
    if not tbt62_vcc_control(TBT62_VCC_ON, ${NAME}_CHANNEL_NUM) then
        sys.debugprint("fault!\\r\\n")
        exit sub
    else
        sys.debugprint("succesful\\r\\n")
    end if
    '****tbt62_${NAME}_init_done****'
    '-----------------------------------------------------------------
        `,
        });


        return blocks;
    }
}
